import {
  FlexContainer,
  Input,
  OptionMenu,
  OptionMenuItem,
  setColorTheme,
} from '@facephi/ui-react';
import styled from 'styled-components/macro';

export const HeaderStyles = styled(FlexContainer)``;

export const AvatarImage = styled.img`
  width: 5.2rem;
  height: 5.2rem;
  border-radius: 5.2rem;
  position: relative;
`;

export const ButtonUser = styled(FlexContainer)`
  > p {
    padding-left: 1rem;
  }
  > svg {
    margin-left: 0.8rem;
  }
`;

export const OptionMenuHeader = styled(OptionMenu)`
  max-width: 20rem;
  margin-top: 1rem;
`;

export const SearchInput = styled(Input)`
  margin-right: 1.6rem;
`;

export const OptionMenuItemStyles = styled(OptionMenuItem)<{ dark?: boolean }>`
  justify-content: flex-start;
  background: ${(props) => (props.dark ? setColorTheme('secondary100') : '')};
  &:hover {
    background: ${(props) => (props.dark ? '' : setColorTheme('grey100'))};
  }
  &:last-of-type {
    height: 4.2rem;
  }
`;

export const ReportNotificationTrigger = styled.span`
  position: relative;
  display: inline-flex;
`;
export const ReportNotificationCount = styled.span`
  position: absolute;
  top: -0.3rem;
  right: -0.3rem;
  min-width: 1.8rem;
  height: 1.8rem;
  padding: 0 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  background: ${setColorTheme('primary400')};
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  pointer-events: none;
`;
export const ReportNotificationMenu = styled(OptionMenu)`
  width: min(38rem, calc(100vw - 3.2rem));
  margin-top: 1rem;
`;
export const ReportNotificationItem = styled(OptionMenuItem)`
  height: auto;
  min-height: 6.4rem;
  align-items: flex-start;
  white-space: normal;
  padding: 1.6rem;
`;
